import { render } from "./GrupoComposer.vue?vue&type=template&id=34438c58&scoped=true"
import script from "./GrupoComposer.vue?vue&type=script&lang=js"
export * from "./GrupoComposer.vue?vue&type=script&lang=js"

import "./GrupoComposer.vue?vue&type=style&index=0&id=34438c58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34438c58"]])

export default __exports__